import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import LoginImageManageLayer from "../components/imageManage/LoginImageManageLayer";

const LoginImageManagePage = () => {
  return (
    <MasterLayout>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Login Image Management</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <a href="/" className="d-flex align-items-center gap-1 hover-text-primary">
              Home
            </a>
          </li>
          <li>-</li>
          <li className="fw-medium">Login Image Management</li>
        </ul>
      </div>
      <LoginImageManageLayer />
    </MasterLayout>
  );
};

export default LoginImageManagePage;
